"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-ignore
var inertia_react_1 = require("@inertiajs/inertia-react");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var useRoute_1 = __importDefault(require("@/Hooks/useRoute"));
var AuthenticationCard_1 = __importDefault(require("@/Jetstream/AuthenticationCard"));
var Button_1 = __importDefault(require("@/Jetstream/Button"));
var Input_1 = __importDefault(require("@/Jetstream/Input"));
var Label_1 = __importDefault(require("@/Jetstream/Label"));
var ValidationErrors_1 = __importDefault(require("@/Jetstream/ValidationErrors"));
function ConfirmPassword() {
    var route = (0, useRoute_1.default)();
    var form = (0, inertia_react_1.useForm)({
        password: '',
    });
    function onSubmit(e) {
        e.preventDefault();
        form.post(route('password.confirm'), {
            onFinish: function () { return form.reset(); },
        });
    }
    return (react_1.default.createElement(AuthenticationCard_1.default, null,
        react_1.default.createElement(inertia_react_1.Head, { title: "Secure Area" }),
        react_1.default.createElement("div", { className: "mb-4 text-sm text-gray-600" }, "This is a secure area of the application. Please confirm your password before continuing."),
        react_1.default.createElement(ValidationErrors_1.default, { className: "mb-4" }),
        react_1.default.createElement("form", { onSubmit: onSubmit },
            react_1.default.createElement("div", null,
                react_1.default.createElement(Label_1.default, { htmlFor: "password" }, "Password"),
                react_1.default.createElement(Input_1.default, { id: "password", type: "password", className: "mt-1 block w-full", value: form.data.password, onChange: function (e) { return form.setData('password', e.currentTarget.value); }, required: true, autoComplete: "current-password", autoFocus: true })),
            react_1.default.createElement("div", { className: "flex justify-end mt-4" },
                react_1.default.createElement(Button_1.default, { className: (0, classnames_1.default)('ml-4', { 'opacity-25': form.processing }), disabled: form.processing }, "Confirm")))));
}
exports.default = ConfirmPassword;
